import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { Amplify } from 'aws-amplify';
import 'aws-amplify/auth/enable-oauth-listener';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import Cookies from 'js-cookie';
import { AppName, createLogger } from '../logging';
const logger = createLogger(AppName.Common, 'auth');
const TOKEN_KEY = 'token';
let tokenCookieOptions = {};
let configuredAuthFlowType;
export const getAuthFlowType = () => configuredAuthFlowType;
export const clearTokenCookie = () => {
  const {
    domain,
    path
  } = tokenCookieOptions;
  Cookies.remove(TOKEN_KEY, {
    domain,
    path: path || '/customer/document/'
  });
};
export const initAmplify = options => {
  const {
    cookies: {
      domain,
      path
    },
    oauth,
    onCustomOAuthState,
    userPoolId,
    identityPoolId,
    userPoolWebClientId
  } = options;
  tokenCookieOptions = {
    domain,
    path
  };
  configuredAuthFlowType = options.authenticationFlowType;
  const tokenKey = TOKEN_KEY;
  const setTokenCookie = function () {
    var _ref = _asyncToGenerator(function* () {
      const {
        tokens
      } = yield fetchAuthSession();
      const idToken = tokens === null || tokens === void 0 ? void 0 : tokens.idToken;
      if (!idToken) {
        throw new Error('No current user');
      }
      const expirationTimeStamp = idToken.payload.exp;
      const expirationDate = expirationTimeStamp ? new Date(expirationTimeStamp * 1000) : undefined;
      const token = idToken.toString();
      Cookies.set(tokenKey, token, {
        domain,
        expires: expirationDate,
        path: path || '/customer/document/',
        sameSite: 'strict',
        secure: window.location.protocol === 'https:'
      });
    });
    return function setTokenCookie() {
      return _ref.apply(this, arguments);
    };
  }();
  const removeTokenCookie = clearTokenCookie;
  Hub.listen('auth', function () {
    var _ref2 = _asyncToGenerator(function* (data) {
      logger.log(`Handling auth event: ${data.payload.event}`);
      switch (data.payload.event) {
        case 'signedIn':
        case 'tokenRefresh':
          try {
            yield setTokenCookie();
          } catch (error) {
            logger.raise(error);
            removeTokenCookie();
          }
          break;
        case 'signedOut':
          removeTokenCookie();
          break;
        case 'customOAuthState':
          if (onCustomOAuthState) {
            onCustomOAuthState(data.payload.data);
          }
          break;
      }
    });
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
  const oauthConfig = oauth !== null && oauth !== void 0 && oauth.domain ? {
    oauth: {
      domain: oauth.domain,
      scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: [oauth.redirectSignIn || window.location.origin],
      redirectSignOut: [oauth.redirectSignOut || window.location.origin],
      responseType: 'code'
    }
  } : undefined;
  if (identityPoolId) {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: userPoolId !== null && userPoolId !== void 0 ? userPoolId : '',
          userPoolClientId: userPoolWebClientId !== null && userPoolWebClientId !== void 0 ? userPoolWebClientId : '',
          identityPoolId,
          ...(oauthConfig ? {
            loginWith: oauthConfig
          } : {})
        }
      }
    });
  } else {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: userPoolId !== null && userPoolId !== void 0 ? userPoolId : '',
          userPoolClientId: userPoolWebClientId !== null && userPoolWebClientId !== void 0 ? userPoolWebClientId : '',
          ...(oauthConfig ? {
            loginWith: oauthConfig
          } : {})
        }
      }
    });
  }
  setTokenCookie().catch(() => {});
};